import { createReducer } from 'redux-act'
import { translatedConfigSelector as configSelector } from '~/config'
import { all } from 'redux-saga/effects'
import { Entity } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'ticket';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = entity.actions;

// WORKERS
export const workers = { ...entity.workers };

// SAGA
export function * saga() {
  yield all(entity.saga);
}

export const reducer = createReducer(entity.reducer, {});

export const getTypes = () => {
  return [
    { value: 'single_ticket', label: 'Single Ticket'},
    { value: 'multiple_tickets', label: 'Multiple Tickets'},
  ]
};

export const STATE_ACTIVE = 'active';
export const STATE_DISABLED = 'disabled';
export const STATE_DELETED = 'deleted';

export const states = {
  STATE_ACTIVE,
  STATE_DISABLED,
  STATE_DELETED
};


export default {
  actions,
  workers,
  saga,
  reducer
}
